module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo-subtitle"
  }, [_vm._v("查询系统")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbbbada6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 490
// module chunks = 1